import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type IMaterialAssessmentItem from './interfaces/IMaterialAssessmentItem';
import type IMaterialAssessmentSlice from './interfaces/IMaterialAssessmentSlice';

export const initialState: IMaterialAssessmentSlice = {
  materialAssessments: [],
  materialId: -1,
};

export const materialAssessmentSlice = createSlice({
  name: 'materialAssessment',
  initialState,
  reducers: {
    setMaterialAssessments: (state, { payload }: PayloadAction<IMaterialAssessmentItem[]>) => {
      state.materialAssessments = payload;
    },
    setMaterialId: (state, { payload }: PayloadAction<number>) => {
      state.materialId = payload;
    },
    resetState: () => initialState,
  },
});

export const { setMaterialAssessments, setMaterialId, resetState } = materialAssessmentSlice.actions;

export default materialAssessmentSlice.reducer;
